import {Types} from 'mongoose';
import {
    DISPUTE_TYPE_BUSINESS,
    DISPUTE_TYPE_FAMILY,
    DISPUTE_TYPE_GOVERNMENT,
    DISPUTE_TYPE_HOSING,
    DISPUTE_TYPE_NEIGHBORHOOD,
    DISPUTE_TYPE_OTHER,
    DISPUTE_TYPE_SCHOOL,
    DISPUTE_TYPE_WORKPLACE,
} from './dispute-type.const';

export const DISPUTE_TYPES = [
    {
        ...DISPUTE_TYPE_BUSINESS,
        value: DISPUTE_TYPE_BUSINESS.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_FAMILY,
        value: DISPUTE_TYPE_FAMILY.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_GOVERNMENT,
        value: DISPUTE_TYPE_GOVERNMENT.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_HOSING,
        value: DISPUTE_TYPE_HOSING.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_NEIGHBORHOOD,
        value: DISPUTE_TYPE_NEIGHBORHOOD.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_SCHOOL,
        value: DISPUTE_TYPE_SCHOOL.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_WORKPLACE,
        value: DISPUTE_TYPE_WORKPLACE.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
    {
        ...DISPUTE_TYPE_OTHER,
        value: DISPUTE_TYPE_OTHER.value.map(item => ({...item, _id: new Types.ObjectId(item._id)})),
    },
];
